import { Spacing } from "@bonusx-global/bx-design-system";
import { memo } from "react";

interface SpacerProps {
  spacingValue: keyof typeof Spacing;
}

function Spacer({ spacingValue }: Readonly<SpacerProps>): JSX.Element {
  return <div data-testid="spacer-section-documents-procedure-details" css={{ height: Spacing[spacingValue] }} />;
}

function spacerPropsComparator(prevProps: Readonly<SpacerProps>, nextProps: Readonly<SpacerProps>): boolean {
  return prevProps.spacingValue === nextProps.spacingValue;
}

export default memo(Spacer, spacerPropsComparator);
